import axios from 'axios';
import Cookies from 'universal-cookie';
import { BACKEND_API_ROOT_V2, GMV_COOKIE } from '../../shared/engage/client-constants';

/* The AI Survey Builder's review surface (sdesregistry/IH-Engage#2543): the "Built with AI"
 * panel on the survey edit page asks whether a builder session is behind this poll.
 *
 * Deliberately NOT through the shared agent's request helpers: their error handler turns a
 * 403 into a navigation to the error page, and here a 403 (no entitlement) or a 404 (the
 * feature is off, or the survey was not built with AI) simply means "no panel". */
export const ENDPOINT = 'survey-builder';

const cookies = new Cookies();

const SurveyBuilderAgent = {
  // GET /gmv-backend-api/v2/survey-builder/projects/:projectId/polls/:pollId/ai-session
  // → metadata (counts, dates, who, review status) or null when there is nothing to show
  aiSession: (projectId, pollId) =>
    axios
      .get(`${BACKEND_API_ROOT_V2}/${ENDPOINT}/projects/${projectId}/polls/${pollId}/ai-session`, {
        headers: { Authorization: `Bearer ${cookies.get(GMV_COOKIE)}` },
      })
      .then((res) => res.data)
      .catch((err) => {
        const status = err.response && err.response.status;
        if (status === 403 || status === 404) {
          return null;
        }
        throw err;
      }),
};

export default SurveyBuilderAgent;
